import { render, staticRenderFns } from "./AppHeaderRouter.vue?vue&type=template&id=fa237368&scoped=true&"
import script from "./AppHeaderRouter.vue?vue&type=script&lang=js&"
export * from "./AppHeaderRouter.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderRouter.vue?vue&type=style&index=0&id=fa237368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa237368",
  null
  
)

export default component.exports